"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppBuilder_1 = require("auto-widget-framework/src/Builder/AppBuilder");
const services_1 = require("../../services");
const PXWidgetFacade_1 = require("../../Extendables/PXWidgetFacade");
const CustomerInitializer_1 = require("./Plugin/WidgetInitializer/CustomerInitializer");
const TemplateInitializer_1 = require("../../Plugin/WidgetInitializer/TemplateInitializer");
const ValuationInitializer_1 = require("./Plugin/WidgetInitializer/ValuationInitializer");
const RactiveComponentsInitializer_1 = require("../../Plugin/WidgetInitializer/RactiveComponentsInitializer");
const SearchVehicleVrnAndDetailsStep_1 = require("./Plugin/WidgetStep/SearchVehicleVrnAndDetailsStep");
const SelectVehicleStep_1 = require("./Plugin/WidgetStep/SelectVehicleStep");
const CarConditionStep_1 = require("./Plugin/WidgetStep/CarConditionStep");
const CustomerStep_1 = require("./Plugin/WidgetStep/CustomerStep");
const ValuationStep_1 = require("./Plugin/WidgetStep/ValuationStep");
const ErrorStep_1 = require("./Plugin/WidgetStep/ErrorStep");
const ExceptionStep_1 = require("./Plugin/WidgetStep/ExceptionStep");
const SelectVehicleForm_1 = require("../../Plugin/FormHandler/SelectVehicleForm");
const QuestionnaireForm_1 = require("../../Plugin/FormHandler/QuestionnaireForm");
const FinalStepForm_1 = require("../../Plugin/FormHandler/FinalStepForm");
const RestartExtension_1 = require("./Plugin/WidgetExtension/RestartExtension");
const TooltipExtension_1 = require("../../Plugin/WidgetExtension/TooltipExtension");
const SaveProgressExtension_1 = require("./Plugin/WidgetExtension/SaveProgressExtension");
const ExceptionExtension_1 = require("./Plugin/WidgetExtension/ExceptionExtension");
const InputJumpExtension_1 = require("../../Plugin/WidgetExtension/InputJumpExtension");
const FormattedNumberComponent_1 = require("../../Plugin/RenderComponent/FormattedNumberComponent");
const PriceComponent_1 = require("../../Plugin/RenderComponent/PriceComponent");
const LoaderRenderComponent_1 = require("../../Plugin/RenderComponent/LoaderRenderComponent");
const UnhandledExceptionErrorHandler_1 = require("./Plugin/ErrorHandler/UnhandledExceptionErrorHandler");
const TestingExtension_1 = require("./Plugin/WidgetExtension/TestingExtension");
const PXWidgetTestingFacade_1 = require("../../Extendables/PXWidgetTestingFacade");
const InchcapeBaseEvents_1 = require("../../Enum/InchcapeBaseEvents");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const FacadeEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/FacadeEvents");
const SelectorWidgetConfig_1 = require("./Extendables/SelectorWidgetConfig");
const Environment_1 = require("../../Enum/Environment");
const BackOneStepExtension_1 = require("../../Plugin/WidgetExtension/BackOneStepExtension");
const InchcapeSelectorEvents_1 = require("./Enum/InchcapeSelectorEvents");
const configs_1 = require("../../configs/configs");
const AssetCleanupExtension_1 = require("../../Plugin/WidgetExtension/AssetCleanupExtension");
const ServiceAlterCompilerPass_1 = require("../../CompilerPass/ServiceAlterCompilerPass");
const TriggerFieldFormExtension_1 = require("../../Plugin/FormExtension/TriggerFieldFormExtension");
const RestrictedValuationStep_1 = require("../../Plugin/WidgetStep/RestrictedValuationStep");
const ProgressBarExtension_1 = require("../../Plugin/WidgetExtension/ProgressBarExtension");
const SelectorWidgetState_1 = require("./Extendables/SelectorWidgetState");
const TooManyValuationErrorHandler_1 = require("./Plugin/ErrorHandler/TooManyValuationErrorHandler");
const DateComponent_1 = require("../../Plugin/RenderComponent/DateComponent");
const ValuationNextStep_1 = require("./Plugin/WidgetStep/ValuationNextStep");
const ValuationNextStepsForm_1 = require("./Plugin/FormHandler/ValuationNextStepsForm");
const FlowValidationInitializer_1 = require("./Plugin/WidgetInitializer/FlowValidationInitializer");
const CollapsibleExtension_1 = require("../../Plugin/WidgetExtension/CollapsibleExtension");
const SearchVehicleVrnOnlyStep_1 = require("./Plugin/WidgetStep/SearchVehicleVrnOnlyStep");
const SearchVehicleVrnOnlyForm_1 = require("./Plugin/FormHandler/SearchVehicleVrnOnlyForm");
const SearchVehicleVrnAndDetailsForm_1 = require("./Plugin/FormHandler/SearchVehicleVrnAndDetailsForm");
class SelectorBundler {
    static bundle(env) {
        let app = new AppBuilder_1.default()
            .addServices(services_1.services)
            .addCompilerPass(new ServiceAlterCompilerPass_1.default())
            // Compiler passes.
            .addCompilerPass(new ServiceAlterCompilerPass_1.default())
            // Container params.
            .addParameter("load_templates", configs_1.configs.loadTemplates.selector)
            // Set extensions.
            .setExtended("widget_config", SelectorWidgetConfig_1.default)
            .setExtended("widget_state", SelectorWidgetState_1.default)
            .setExtended("widget_facade", PXWidgetFacade_1.default)
            // Add initializer plugins.
            .addPlugin(FlowValidationInitializer_1.FlowValidationInitializerDefinition)
            .addPlugin(CustomerInitializer_1.CustomerInitializerDefinition)
            .addPlugin(TemplateInitializer_1.TemplateInitializerDefinition)
            .addPlugin(ValuationInitializer_1.ValuationInitializerDefinition)
            .addPlugin(RactiveComponentsInitializer_1.RactiveComponentsInitializerDefinition)
            // Add steps.
            .addPlugin(SearchVehicleVrnOnlyStep_1.SearchVehicleVrnOnlyStepDefinition)
            .addPlugin(SearchVehicleVrnAndDetailsStep_1.SearchVehicleVrnAndDetailsStepDefinition)
            .addPlugin(SelectVehicleStep_1.SelectVehicleStepDefinition)
            .addPlugin(CarConditionStep_1.CarConditionStepDefinition)
            .addPlugin(CustomerStep_1.CustomerStepDefinition)
            .addPlugin(ValuationStep_1.ValuationStepDefinition)
            .addPlugin(ValuationNextStep_1.ValuationNextStepDefinition)
            .addPlugin(ErrorStep_1.ErrorStepDefinition)
            .addPlugin(ExceptionStep_1.ExceptionStepDefinition)
            .addPlugin(RestrictedValuationStep_1.RestrictedValuationStepDefinition)
            // Add step forms.
            .addPlugin(SearchVehicleVrnOnlyForm_1.SearchVehicleVrnOnlyFormDefinition)
            .addPlugin(SearchVehicleVrnAndDetailsForm_1.SearchVehicleVrnAndDetailsFormDefinition)
            .addPlugin(SelectVehicleForm_1.SelectVehicleFormDefinition)
            .addPlugin(QuestionnaireForm_1.QuestionnaireFormDefinition)
            .addPlugin(FinalStepForm_1.FinalStepFormDefinition)
            .addPlugin(ValuationNextStepsForm_1.ValuationNextStepsFormDefinition)
            // Add widget extensions.
            .addPlugin(RestartExtension_1.RestartExtensionDefinition)
            .addPlugin(TooltipExtension_1.TooltipExtensionDefinition)
            .addPlugin(SaveProgressExtension_1.SaveProgressExtensionDefinition)
            .addPlugin(ExceptionExtension_1.ExceptionExtensionDefinition)
            .addPlugin(InputJumpExtension_1.InputJumpExtensionDefinition)
            .addPlugin(BackOneStepExtension_1.BackOneStepExtensionDefinition)
            .addPlugin(AssetCleanupExtension_1.AssetCleanupExtensionDefinition)
            .addPlugin(ProgressBarExtension_1.ProgressBarExtensionDefinition)
            .addPlugin(CollapsibleExtension_1.CollapsibleExtensionDefinition)
            // Add form extensions.
            .addPlugin(TriggerFieldFormExtension_1.TriggerFieldFormExtensionDefinition)
            // Ractive components.
            .addPlugin(FormattedNumberComponent_1.FormattedNumberComponentDefintion)
            .addPlugin(PriceComponent_1.PriceComponentPluginDefintion)
            .addPlugin(LoaderRenderComponent_1.LoaderComponentPluginDefintion)
            .addPlugin(DateComponent_1.DateComponentPluginDefintion)
            // Error handlers.
            .addPlugin(UnhandledExceptionErrorHandler_1.UnhandledExceptionErrorHandlerDefinition)
            .addPlugin(TooManyValuationErrorHandler_1.TooManyValuationErrorHandlerDefinition);
        if (env === Environment_1.Environment.DEV) {
            // Extensions used for testing purposes. Comment when not needed.
            app.addPlugin(TestingExtension_1.TestingExtensionDefinition)
                .setExtended("widget_facade", PXWidgetTestingFacade_1.default);
        }
        return {
            Events: Object.assign(Object.assign(Object.assign(Object.assign({}, InchcapeBaseEvents_1.InchcapeBaseEvents), InchcapeSelectorEvents_1.InchcapeSelectorEvents), WidgetEvents_1.WidgetEvents), FacadeEvents_1.FacadeEvents),
            Widget: app.create(),
        };
    }
}
exports.default = SelectorBundler;
